import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

export function FilingShell({ children, title }: { children: ReactNode; title: string }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border bg-card">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-4">
          <Link to="/filings" className="text-sm font-semibold tracking-[0.18em] text-primary">
            FIDUCIARYFILE
          </Link>
          <nav className="flex items-center gap-4 text-sm text-muted-foreground">
            <Link to="/filings" data-jr-key="filings-nav-link" className="hover:text-foreground">
              Filings
            </Link>
            <Link to="/filing-status" data-jr-key="filing-status-nav-link" className="hover:text-foreground">
              Status
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-5 py-8">
        <p className="mb-2 text-xs font-medium uppercase tracking-[0.16em] text-muted-foreground">Fiduciary record</p>
        <h1 className="mb-7 text-2xl font-semibold tracking-tight">{title}</h1>
        {children}
      </main>
    </div>
  );
}
